// import { useParams } from "react-router-dom";
import { useSelector } from 'react-redux';

const useAdministrationResource = (action) => {
  const { accountId, authenticityToken } = useSelector((state) => state.internalReducer.internal);

  const getResource = () => {
    switch (action) {
      case 'fetchFormTemplates':
        return 'administration/form_templates';

      default:
        return '';
    }
  };

  return {
    accountId: accountId,
    resource: getResource(),
    authenticityToken: authenticityToken,
  };
};

export default useAdministrationResource;
